<template>
    <sections>
        <section-text heading="About Us" content="<article-about />"></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'About Us | ' + $config.public.siteName,
    description:
        'Above all else, we have unbeatable relationships with the staff we provide and the clients we support - that sets us apart from our competition.',
    index: true,
});
</script>
